import { useEffect, useState } from "react";
import { DEFAULT_MARKETPLACE_RANGE, formatPercent } from "../../../../constants/automapMarketplaceAnalyticsConstants";
import { fetchInventoryHealthAnalytics } from "../../../../services/automapMarketplaceAnalyticsApi";
import { AnalyticsSummaryGrid } from "../AdminAnalyticsShared";
import { ActionLinksPanel, MarketplaceAnalyticsShell } from "./AdminMarketplaceAnalyticsShared";

export default function AdminInventoryHealthAnalyticsPage() {
  const [range, setRange] = useState(DEFAULT_MARKETPLACE_RANGE);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchInventoryHealthAnalytics(range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar analytics."))
      .finally(() => setLoading(false));
  }, [range]);

  const metrics = payload?.metrics;

  return (
    <MarketplaceAnalyticsShell
      active="inventory-health"
      title="Salud de inventario"
      description="Calidad, frescura, duplicados y dealers que necesitan seguimiento."
      range={range}
      onRangeChange={setRange}
      viewEvent="inventory_health_analytics_viewed"
    >
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error && metrics ? (
        <>
          <AnalyticsSummaryGrid
            items={[
              { label: "Calidad promedio", value: metrics.averageQualityScore ?? "—" },
              { label: "Frescura", value: formatPercent(metrics.inventoryFreshnessPercent) },
              { label: "Stale", value: metrics.staleListings },
              { label: "Sin fotos", value: metrics.missingPhotos },
              { label: "Sin precio", value: metrics.missingPrice },
              { label: "Sin kilometraje", value: metrics.missingMileage },
              { label: "Duplicados", value: metrics.duplicateCandidates },
              { label: "Outliers", value: metrics.outlierFlags },
              { label: "Alto riesgo", value: metrics.highRiskListings },
              { label: "Revisión admin", value: metrics.needsReview },
            ]}
          />
          <ActionLinksPanel links={payload.actionLinks} />
          <section className="dealer-state-box">
            <h3>Dealers con inventario stale</h3>
            {!payload.dealersWithStale?.length ? (
              <p className="muted">Ninguno.</p>
            ) : (
              <table className="dealer-inventory-table">
                <thead>
                  <tr>
                    <th>Dealer</th>
                    <th>Stale</th>
                  </tr>
                </thead>
                <tbody>
                  {payload.dealersWithStale.map((row) => (
                    <tr key={row.dealerId}>
                      <td>{row.dealerName}</td>
                      <td>{row.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </section>
          <section className="dealer-state-box">
            <h3>Dealers con baja calidad</h3>
            {!payload.dealersLowQuality?.length ? (
              <p className="muted">Ninguno.</p>
            ) : (
              <table className="dealer-inventory-table">
                <thead>
                  <tr>
                    <th>Dealer</th>
                    <th>Listings</th>
                  </tr>
                </thead>
                <tbody>
                  {payload.dealersLowQuality.map((row) => (
                    <tr key={row.dealerId}>
                      <td>{row.dealerName}</td>
                      <td>{row.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </section>
        </>
      ) : null}
    </MarketplaceAnalyticsShell>
  );
}
